// Pure derivations of the lazy-recheck change summary, shared between the popup analytics
// (changes_presented) and the booking-created rate-check fields. `comparison` is the
// RecheckAlternative comparison object.

function getRateCheckChangeTypes({ price_changed, old_price, new_price, deadline_changed, board_changed } = {}) {
    const change_types = [];
    if (price_changed && typeof old_price === 'number' && typeof new_price === 'number') {
        change_types.push(new_price > old_price ? 'price_increase' : 'price_decrease');
    }
    if (deadline_changed) {
        change_types.push('policy_change');
    }
    if (board_changed) {
        change_types.push('board_change');
    }
    return change_types;
}

// Snapshot stashed at popup time and attached to a booking made at the same hotel in the same search.
function buildRateCheckContext(comparison) {
    const { old_price, new_price, price_changed, room_changed } = comparison ?? {};
    return {
        triggered_by_rate_check: true,
        rate_check_change_types: getRateCheckChangeTypes(comparison ?? {}),
        rate_check_original_price: old_price ?? null,
        rate_check_price_delta:
            price_changed && typeof old_price === 'number' && typeof new_price === 'number'
                ? new_price - old_price
                : null,
        rate_check_same_room: typeof room_changed === 'boolean' ? !room_changed : null,
    };
}

module.exports = { getRateCheckChangeTypes, buildRateCheckContext };
